
/////////////////////////////////////////////
// M022 image gallery
function initImageGallery() {

    if ($(".imageGallery").length > 0) {

        $(".imageGallery").each(function () {

			var $ig = $(this);

			var $sliderContainer = $ig.find(".imageGalleryContainer");
            $sliderContainer.slick({
				centerMode: true,
				//centerPadding: '80px',
				slidesToShow: 1,
				infinite: true,
				dots: false,
				arrows: false,
				adaptiveHeight: false,
				mobileFirst: true,
				speed: 300,
				responsive: [
				{
					breakpoint: _breakpointMedium,
					settings: {
					  //centerPadding: '200px',
					  slidesToShow: 3
					}
				  },
				  {
					breakpoint: _breakpointLarge,
					settings: {
					  //centerPadding: '100px',
					  slidesToShow: 3
					}
				  }
				]
			});

			//handle next/prev image click
			$sliderContainer.find('.slick-slide').on('click', function(e) {
				e.stopPropagation();

				var $clickedSlide = $( e.currentTarget );
				var $slider = $clickedSlide.closest(".slick-slider");
				var $slickTrack = $clickedSlide.parent(".slick-track");
				var $centerSlide = $slickTrack.children(".slick-center").not(".slick-cloned");
				
				var $allSlides = $slickTrack.children(".slick-slide");
				var $clonedSlides = $slickTrack.children(".slick-cloned");
				
				var clickedSlideIndex = parseFloat($clickedSlide.attr("data-slick-index"));
				var centerSlideIndex = parseFloat($centerSlide.attr("data-slick-index"));
				var numSlides = $allSlides.length - $clonedSlides.length;
				
				/*
				console.log("### click! ###");
				console.log("clickedSlideIndex:" + clickedSlideIndex);
				console.log("centerSlideIndex:" + centerSlideIndex);
				*/

				if (centerSlideIndex == clickedSlideIndex) {
					return false;
				} 
				else if (clickedSlideIndex == (numSlides - 1)) {
					if (centerSlideIndex == 0) {
						$slider.slick("slickPrev");
					} 
					else {
						$slider.slick("slickNext");
					}
				} 
				else if (clickedSlideIndex == 0) {
					if (centerSlideIndex == (numSlides - 1)) {
						$slider.slick("slickNext");
					} 
					else {
						$slider.slick("slickPrev");
					}
				} 
				else if (clickedSlideIndex < centerSlideIndex) {
					$slider.slick("slickPrev");
				} 
				else {  
					$slider.slick("slickNext");
				}	
				
				//add special marker class
				$clickedSlide.addClass("slick-now");
			}); 
			
            if (_blazy) {
                _blazy.revalidate();
            }

            $ig.find(".imageGalleryNavigationText").children(".imageGalleryVar1").html("1");

            var subline = $ig.find(".slick-current").find(".subline").html();
            $ig.find(".imageSubline").html(subline);

            if ($ig.find(".imageGalleryContainer").slick('getSlick')) {
                var slideCount = $ig.find(".imageGalleryContainer").slick('getSlick').slideCount;
                $ig.find(".imageGalleryNavigationText").children(".imageGalleryVar2").html(slideCount);
            }

            $ig.find(".imageGalleryContainer").on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var $currentSlide = $(slick.$slides.get(currentSlide));
    			var $nextSlide = $(slick.$slides.get(nextSlide));

				//add special marker class
				$(".slick-now").removeClass("slick-now");
				$nextSlide.addClass("slick-now");
			});

            $ig.find(".imageGalleryContainer").on("afterChange", function (event, slick, currentSlide) {
				//change nav text
                $ig.find(".imageGalleryNavigationText").children(".imageGalleryVar1").html(currentSlide + 1);
                var subline = $ig.find(".slick-current").find(".subline").html();
                $ig.find(".imageSubline").html(subline);

				//clean up very special marker class
				$ig.find(".slick-now-or-never").removeClass("slick-now-or-never");
            });
			
            $ig.find(".imageGalleryButtonPrev").click(function () {
				//add very special marker class
				$ig.find(".slick-center").prev().addClass("slick-now-or-never");
				//move slider
				$ig.find('.imageGalleryContainer').slick('slickPrev');
            });
            $ig.find(".imageGalleryButtonNext").click(function () {
				//add very special marker class
				$ig.find(".slick-center").next().addClass("slick-now-or-never");
				//move slider
				$ig.find('.imageGalleryContainer').slick('slickNext');
            });
			$ig.find(".imageGalleryButtonPrev").on("keydown", handleKeyDownForClick);
			$ig.find(".imageGalleryButtonNext").on("keydown", handleKeyDownForClick);
        });
    }
}

function updateImageGallery() {

    $(".imageGalleryElement").each(function () {
        var w = $(this).width();
        var ratio = 16 / 9;
        var h = Math.round(w / ratio);
        $(this).css("height", h + "px");
        //$(this).css("height", "auto");
    })

}